import React from 'react';
import { Link } from 'react-router-dom';
import ghostSVG from '../../assets/images/icon-ghost.svg'

export default function PageNotFound() {
    return (
        <div className="site-content">
            <div className="container">
                <div className="error-404">
                    <div className="row">
                        <div className="col-md-8 offset-md-2">
                            <figure className="error-404__figure">
                                <img src={ghostSVG} alt="" />
                            </figure>
                            <header className="error__header">
                                <h2 className="error__title">Página não encontrada</h2>
                                <h3 className="error__subtitle">Parece que temos um problema!</h3>
                            </header>
                            <div className="error__description">
                                A página que você está procurando foi movida ou não existe mais, se desejar, pode retornar à nossa página inicial.
                            </div>
                            <footer className="error__cta">
                                <Link to="/" className="btn btn-primary">Voltar para Home</Link>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}